// Firestore database operations for Sadhana data
import { collection, addDoc, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from './config';

// Simple Sadhana Data Operations
export const sadhanaService = {
  // Save new sadhana session as a post
  async saveSadhanaInfo(data) {
    try {
      console.log('Saving new sadhana session:', data);
      
      // Create a new document in the SadhanaData collection
      const sadhanaCollection = collection(db, 'SadhanaData');
      
      const sessionData = {
        date: data.date,
        location: data.location,
        createdAt: new Date().toISOString(),
        timestamp: Date.now()
      };
      
      // Add as a new document (each save creates a new post)
      const docRef = await addDoc(sadhanaCollection, sessionData);
      console.log('✅ Session saved with ID:', docRef.id);
      
      return { success: true, id: docRef.id };
    } catch (error) {
      console.error('❌ Error saving session:', error);
      return { success: false, error: error.message };
    }
  },

  // Get the most recent sadhana session
  async getCurrentSadhanaInfo() {
    try {
      console.log('Getting latest sadhana session...');
      
      const sadhanaCollection = collection(db, 'SadhanaData');
      const q = query(sadhanaCollection, orderBy('timestamp', 'desc'), limit(1));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        console.log('No sessions found');
        return { success: true, data: null };
      }
      
      const latestDoc = querySnapshot.docs[0];
      const data = latestDoc.data();
      console.log('✅ Latest session:', data);

      return { success: true, data: { ...data, id: latestDoc.id } };
    } catch (error) {
      console.error('❌ Error getting session:', error);
      return { success: false, error: error.message };
    }
  },

  // Get all sadhana sessions (for history)
  async getAllSessions() {
    try {
      const sadhanaCollection = collection(db, 'SadhanaData');
      const q = query(sadhanaCollection, orderBy('timestamp', 'desc'));
      const querySnapshot = await getDocs(q);
      
      const sessions = [];
      querySnapshot.forEach((doc) => {
        sessions.push({ id: doc.id, ...doc.data() });
      });
      
      console.log(`✅ Found ${sessions.length} sessions`);
      return { success: true, data: sessions };
    } catch (error) {
      console.error('❌ Error getting sessions:', error);
      return { success: false, error: error.message };
    }
  }
};
